<template>
  <div class="svg-image">
    <svg viewBox="0 0 603 483" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="infoplay">
        <g id="Texto">
          <g id="Play">
            <g id="Vector">
              <path d="M379.5 450.5V325H393.5V450.5H379.5Z" fill="#C184F1" />
              <path
                d="M528.5 357.5H513L549.5 446.5L534 482.5H549.5L603 357.5H587L557 426.5L528.5 357.5Z"
                fill="#C184F1"
              />
            </g>
            <g id="p">
              <path
                id="Subtract"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M321.5 452C348.286 452 370 430.286 370 403.5C370 376.714 348.286 355 321.5 355C294.714 355 273 376.714 273 403.5C273 430.286 294.714 452 321.5 452ZM321 439C340.33 439 356 423.33 356 404C356 384.67 340.33 369 321 369C301.67 369 286 384.67 286 404C286 423.33 301.67 439 321 439Z"
                fill="#C184F1"
              />
              <path
                id="Vector_2"
                d="M286.5 483H273V398.5H286.5V438V483Z"
                fill="#C184F1"
              />
            </g>
            <g id="a">
              <path
                id="Subtract_2"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M453.5 452C480.286 452 502 430.286 502 403.5C502 376.714 480.286 355 453.5 355C426.714 355 405 376.714 405 403.5C405 430.286 426.714 452 453.5 452ZM453 439C472.33 439 488 423.33 488 404C488 384.67 472.33 369 453 369C433.67 369 418 384.67 418 404C418 423.33 433.67 439 453 439Z"
                fill="#C184F1"
              />
              <path
                id="Vector_3"
                d="M502 452H488V399H502V423.775V452Z"
                fill="#C184F1"
              />
            </g>
          </g>
          <g id="Info">
            <g id="Vector_4">
              <path d="M0.5 348V325.5H13V348H0.5Z" fill="#C4C4C4" />
              <path d="M0.5 451V358H13V451H0.5Z" fill="#C4C4C4" />
              <path
                d="M39.5 451H25.5V391C28 379.167 39.9 355.5 67.5 355.5C95.1 355.5 106 379.167 108 391V451H94.5V391C93 383.5 85.5 368.5 67.5 368.5C49.5 368.5 41.3333 383.5 39.5 391V451Z"
                fill="#C4C4C4"
              />
              <path
                d="M133.5 451H120V357.5C120 330.7 144.333 324.667 156.5 325V337.5C134.9 337.5 132.167 350.833 133.5 357.5H156.5V370H133.5V451Z"
                fill="#C4C4C4"
              />
            </g>
            <path
              id="Subtract_3"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M213.5 451C240.286 451 262 429.286 262 402.5C262 375.714 240.286 354 213.5 354C186.714 354 165 375.714 165 402.5C165 429.286 186.714 451 213.5 451ZM213 438C232.33 438 248 422.33 248 403C248 383.67 232.33 368 213 368C193.67 368 178 383.67 178 403C178 422.33 193.67 438 213 438Z"
              fill="#C4C4C4"
            />
          </g>
        </g>
        <g id="Logo">
          <circle id="Circulo" cx="300" cy="150" r="150" fill="#C4C4C4" />
          <g id="Simbolo">
            <path
              id="Subtract_4"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M224 280.336L217.143 283.355C213.806 284.824 210.069 282.342 210.129 278.696L211.963 167.912C212.035 163.593 218.247 163.003 219.13 167.231C219.363 168.345 220.106 169.285 221.135 169.768L334.054 222.827C337.938 224.652 337.87 230.199 333.943 231.928L256 266.246V197C256 188.163 248.837 181 240 181C231.163 181 224 188.163 224 197V280.336Z"
              fill="#8300EA"
            />
            <path
              id="Subtract_5"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M390 150C390 199.706 349.706 240 300 240C284.018 240 269.009 235.834 256 228.53V197C256 188.163 248.837 181 240 181C231.163 181 224 188.163 224 197V198.229C215.135 184.289 210 167.744 210 150C210 100.294 250.294 60 300 60C349.706 60 390 100.294 390 150ZM339.462 151C343.04 153.373 343.04 158.627 339.462 161L285.817 196.585C281.828 199.231 276.5 196.371 276.5 191.585L276.5 120.415C276.5 115.629 281.828 112.769 285.817 115.415L339.462 151ZM240 172C248.837 172 256 164.837 256 156C256 147.163 248.837 140 240 140C231.163 140 224 147.163 224 156C224 164.837 231.163 172 240 172Z"
              fill="#8300EA"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.svg-image {
  transition: all 0.35s ease;

  * {
    path {
      transition: all 0.5s ease;
    }
  }
  &:hover {
    #Info,
    #Logo {
      path,
      circle {
        fill: white;
      }
    }
    #Play,
    #Simbolo {
      path {
        fill: #fd0000;
      }
    }
  }
}
</style>
